(() => {
  const CART_OPEN_CLASS = 'upcartPopupShow';
  const CART_POPUP_SELECTOR = '#CartPopup';

  const CLOSE_BUTTON_SELECTOR = '.upcart-header-close-button.styles_Header__closeButton__';
  const DELETE_BUTTON_SELECTOR = '.styles_TrashButton__deleteButton__';
  const TOGGLE_SELECTOR = '.styles_ToggleSwitch__';

  let lastFocusedElement = null;
  let lastFocusedCartElementSelector = null;
  let wasCartOpen = document.body.classList.contains(CART_OPEN_CLASS);
  let cartPopupObserver = null;

  const getElementSelector = element => {
    if (!element) return null;

    if (element.id) return `#${element.id}`;

    if (element.getAttribute('aria-label')) {
      return `[aria-label="${element.getAttribute('aria-label')}"]`;
    }

    if (element.className && typeof element.className === 'string') {
      return `.${element.className.trim().split(/\s+/).join('.')}`;
    }

    return null;
  };

  const makeCartElementsAccessible = () => {
    document.querySelectorAll(CLOSE_BUTTON_SELECTOR).forEach(button => {
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
      button.setAttribute('aria-label', 'Close cart');
    });

    document.querySelectorAll(DELETE_BUTTON_SELECTOR).forEach(button => {
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
      button.setAttribute('aria-label', 'Remove item');
    });

    document.querySelectorAll(TOGGLE_SELECTOR).forEach(toggle => {
      toggle.setAttribute('role', 'switch');
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-label', 'Toggle option');

      const isChecked =
        toggle.classList.contains('active') ||
        toggle.classList.contains('checked') ||
        toggle.getAttribute('aria-checked') === 'true';

      toggle.setAttribute('aria-checked', isChecked ? 'true' : 'false');
    });
  };

  const focusCloseButton = () => {
    const closeButton = document.querySelector(CLOSE_BUTTON_SELECTOR);

    if (!closeButton) return false;

    closeButton.focus();
    return document.activeElement === closeButton;
  };

  const restoreCartFocus = () => {
    const cartPopup = document.querySelector(CART_POPUP_SELECTOR);

    if (!cartPopup) return focusCloseButton();

    if (
      lastFocusedElement &&
      document.contains(lastFocusedElement) &&
      cartPopup.contains(lastFocusedElement) &&
      typeof lastFocusedElement.focus === 'function'
    ) {
      lastFocusedElement.focus();
      return true;
    }

    if (lastFocusedCartElementSelector) {
      const restoredElement = cartPopup.querySelector(lastFocusedCartElementSelector);

      if (restoredElement && typeof restoredElement.focus === 'function') {
        restoredElement.focus();
        return true;
      }
    }

    return focusCloseButton();
  };

  const keepFocusInsideCart = () => {
    const cartPopup = document.querySelector(CART_POPUP_SELECTOR);
    const isCartOpen = document.body.classList.contains(CART_OPEN_CLASS);

    if (!isCartOpen || !cartPopup) return;

    const activeElement = document.activeElement;

    if (!activeElement || !cartPopup.contains(activeElement)) {
      restoreCartFocus();
    }
  };

  const observeCartPopup = () => {
    const cartPopup = document.querySelector(CART_POPUP_SELECTOR);

    if (!cartPopup || cartPopupObserver) return;

    cartPopupObserver = new MutationObserver(() => {
      makeCartElementsAccessible();

      setTimeout(() => {
        keepFocusInsideCart();
      }, 50);
    });

    cartPopupObserver.observe(cartPopup, {
      childList: true,
      subtree: true
    });
  };

  const waitForCloseButtonAndFocus = () => {
    makeCartElementsAccessible();
    observeCartPopup();

    if (focusCloseButton()) return;

    let attempts = 0;

    const interval = setInterval(() => {
      attempts += 1;

      makeCartElementsAccessible();
      observeCartPopup();

      if (focusCloseButton() || attempts >= 20) {
        clearInterval(interval);
      }
    }, 100);
  };

  const restorePageFocus = () => {
    const cartLink = document.querySelector('.header__cart-link a');

    if (
      cartLink &&
      typeof cartLink.focus === 'function'
    ) {
      cartLink.focus();
    }

    lastFocusedElement = null;
    lastFocusedCartElementSelector = null;
  };

  document.addEventListener('focusin', event => {
    const cartPopup = document.querySelector(CART_POPUP_SELECTOR);

    if (cartPopup && cartPopup.contains(event.target)) {
      lastFocusedElement = event.target;
      lastFocusedCartElementSelector = getElementSelector(event.target);
    }

    setTimeout(() => {
      keepFocusInsideCart();
    }, 0);
  });

  document.addEventListener('keydown', event => {
    const element = event.target.closest(
      `${CLOSE_BUTTON_SELECTOR}, ${DELETE_BUTTON_SELECTOR}, ${TOGGLE_SELECTOR}`
    );

    if (!element) return;

    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      element.click();

      if (element.matches(TOGGLE_SELECTOR)) {
        setTimeout(() => {
          makeCartElementsAccessible();
        }, 0);
      }
    }
  });

  const bodyObserver = new MutationObserver(() => {
    const isCartOpen = document.body.classList.contains(CART_OPEN_CLASS);

    makeCartElementsAccessible();
    observeCartPopup();


    if (isCartOpen && !wasCartOpen) {
      lastFocusedElement = document.activeElement;

      setTimeout(() => {
        const cartDrawer = document.querySelector('#CartPopup');
        cartDrawer && cartDrawer.click();
        waitForCloseButtonAndFocus();
      }, 2400);
    }

    if (!isCartOpen && wasCartOpen) {
      setTimeout(() => {
        restorePageFocus();
      }, 100);
    }

    wasCartOpen = isCartOpen;
  });

  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true
  });

  makeCartElementsAccessible();
  observeCartPopup();
})();